export default "/_next/static/images/roi-squiggle2-8dad62127ac672d99c6622c4cca34450.svg";